// Unfortunately we cannot use numeric enums because they are not typesafe
// more info https://github.com/microsoft/TypeScript/issues/32690
import { QaError } from './QaErrors';

export enum OperationType {
  ConfigScript = 'ConfigScript',
}

export type SelectedOperation = {
  type: OperationType.ConfigScript;
  qaError: QaError;
  onComplete: () => void;
};
